const selectCourseTabs = state => state.courseTabs;

export default selectCourseTabs;
